'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var _require = require('it-pipe'),
    pipe = _require.pipe;

var lp = require('it-length-prefixed');

var Message = require('../message');

var handlers = require('./handlers');

var utils = require('../utils');
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').MuxedStream} MuxedStream
 */

/**
 * @param {import('../index')} dht
 */


module.exports = function (dht) {
  var log = utils.logger(dht.peerId, 'rpc');
  var getMessageHandler = handlers(dht);
  /**
   * Process incoming DHT messages.
   *
   * @param {PeerId} peerId
   * @param {Message} msg
   */

  function handleMessage(_x, _x2) {
    return _handleMessage.apply(this, arguments);
  }
  /**
   * Handle incoming streams on the dht protocol
   *
   * @param {object} props
   * @param {MuxedStream} props.stream
   * @param {import('libp2p-interfaces/src/connection').Connection} props.connection
   */


  function _handleMessage() {
    _handleMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peerId, msg) {
      var handler;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // get handler & execute it
              handler = getMessageHandler(msg.type);
              _context.prev = 1;
              _context.next = 4;
              return dht._add(peerId);

            case 4:
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              log.error('Failed to update the kbucket store', _context.t0);

            case 9:
              if (handler) {
                _context.next = 12;
                break;
              }

              log.error("no handler found for message type: ".concat(msg.type));
              return _context.abrupt("return");

            case 12:
              return _context.abrupt("return", handler(peerId, msg));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 6]]);
    }));
    return _handleMessage.apply(this, arguments);
  }

  function onIncomingStream(_x3) {
    return _onIncomingStream.apply(this, arguments);
  }

  function _onIncomingStream() {
    _onIncomingStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
      var stream, connection, peerId, idB58Str;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              stream = _ref2.stream, connection = _ref2.connection;
              peerId = connection.remotePeer;
              _context3.prev = 2;
              _context3.next = 5;
              return dht._add(peerId);

            case 5:
              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](2);
              log.error(_context3.t0);

            case 10:
              idB58Str = peerId.toB58String();
              log('from: %s', idB58Str);
              _context3.next = 14;
              return pipe(stream.source, lp.decode(),
              /**
               * @param {AsyncIterable<Uint8Array>} source
               */
              function (source) {
                return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, msg, desMessage, res;

                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _iteratorAbruptCompletion = false;
                          _didIteratorError = false;
                          _context2.prev = 2;
                          _iterator = _asyncIterator(source);

                        case 4:
                          _context2.next = 6;
                          return _awaitAsyncGenerator(_iterator.next());

                        case 6:
                          if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
                            _context2.next = 18;
                            break;
                          }

                          msg = _step.value;
                          // handle the message
                          desMessage = Message.deserialize(msg.slice());
                          _context2.next = 11;
                          return _awaitAsyncGenerator(handleMessage(peerId, desMessage));

                        case 11:
                          res = _context2.sent;

                          if (!res) {
                            _context2.next = 15;
                            break;
                          }

                          _context2.next = 15;
                          return res.serialize();

                        case 15:
                          _iteratorAbruptCompletion = false;
                          _context2.next = 4;
                          break;

                        case 18:
                          _context2.next = 24;
                          break;

                        case 20:
                          _context2.prev = 20;
                          _context2.t0 = _context2["catch"](2);
                          _didIteratorError = true;
                          _iteratorError = _context2.t0;

                        case 24:
                          _context2.prev = 24;
                          _context2.prev = 25;

                          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                            _context2.next = 29;
                            break;
                          }

                          _context2.next = 29;
                          return _awaitAsyncGenerator(_iterator.return());

                        case 29:
                          _context2.prev = 29;

                          if (!_didIteratorError) {
                            _context2.next = 32;
                            break;
                          }

                          throw _iteratorError;

                        case 32:
                          return _context2.finish(29);

                        case 33:
                          return _context2.finish(24);

                        case 34:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, null, [[2, 20, 24, 34], [25,, 29, 33]]);
                }))();
              }, lp.encode(), stream.sink);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 7]]);
    }));
    return _onIncomingStream.apply(this, arguments);
  }

  return onIncomingStream;
};